<template>
  <div v-if="visible" class="sheet-root">
    <!-- 背景遮罩 -->
    <div class="sheet-mask" @click="handleClose"></div>

    <!-- 半屏面板：支持手势拖拽 -->
    <div class="sheet-panel" :class="{ 'sheet-panel--animating': animating }" :style="panelStyle">
      <!-- 顶部活动横条（绿色） -->
      <div class="sheet-hero">
        <div class="sheet-hero__left">
          <span class="sheet-hero__tag">Holiday Haul</span>
        </div>
        <div class="sheet-hero__right">
          <span class="sheet-hero__link">30-day no-reason return</span>
        </div>
      </div>
      <!-- 顶部：拖拽条 + 搜索/订单/购物车 -->
      <div class="sheet-header" @touchstart.passive="onTouchStart" @touchmove="onTouchMove"
        @touchend.passive="onTouchEnd">
        <div class="sheet-handle"></div>
        <!-- 右上角关闭 -->
        <button class="live-hot-bar__close" @click.stop="handleClose">✕</button>



        <!-- 店铺 / 橱窗信息 -->
        <div class="sheet-shop">
          <div class="sheet-shop__info">
            <div class="sheet-shop__title">
              Green bud Store · Product Showcase
              <span class="sheet-shop__arrow">›</span>
            </div>
            <div class="sheet-shop__meta">
              226.4K followers · 597.1K sold
            </div>
          </div>

          <div class="sheet-shop__icons">
            <!-- <button class="sheet-shop__icon">🎟️</button>
            <button class="sheet-shop__icon sheet-shop__cart">
              🛒
              <span v-if="cartCount > 0" class="sheet-icon-badge">
                {{ cartCount > 99 ? '99+' : cartCount }}
              </span>
            </button> -->
          </div>
        </div>

        <!-- 优惠条 -->
        <!-- <div class="sheet-coupon">
          <div class="sheet-coupon__text">
            Get 10% off orders over $30
          </div>
          <button class="sheet-coupon__btn">
            Claim
          </button>
        </div> -->
      </div>

      <!-- 商品列表 -->
      <div class="sheet-list" v-loading="loading">
        <div v-for="(item,index) in filteredProducts" :key="item.id" class="sheet-item"
          :class="{ 'sheet-item--active': item.id === activeId }" @click="onSelect(item)">
          <!-- 左侧缩略图 -->
          <div class="item-thumb">
            <img :src="item.image" alt="" />
            <div class="item-status" v-if="item.statusText">
              {{ item.statusText }}
            </div>
            <div class="item-index">
              {{ index + 1 }}
            </div>
          </div>

          <!-- 右侧信息 -->
          <div class="item-info">
            <div class="item-title">
              {{ item.title }}
            </div>

            <div class="item-subtitle" v-if="item.subtitle">
              {{ item.subtitle }}
            </div>

            <div class="item-tags" v-if="item.tags">
              <span v-for="(tag, idx) in item.tags || []" :key="idx" class="item-tag">
                {{ tag }}
              </span>
            </div>

            <div class="item-bottom">
              <div class="item-price">
                <span class="item-price-symbol">$</span>
                <span class="item-price-value">{{ item.price }}</span>
                <span v-if="item.priceOrigin" class="item-price-origin">
                  ${{ item.priceOrigin }}
                </span>
              </div>

              <button class="item-buy" @click.stop="onBuy(item)">
                buy
              </button>
            </div>
          </div>
        </div>

        <div v-if="!filteredProducts.length" class="sheet-empty">
          No related products available.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LiveProductListSheet',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    products: {
      type: Array,
      default: function () {
        return []
      }
    },
    activeId: {
      type: [String, Number, null],
      default: null
    },
    // 顶部购物车数量（用于小红点）
    cartCount: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      keyword: '',
      // 拖拽相关
      dragging: false,
      startY: 0,
      baseOffsetY: 0,
      offsetY: 0,     // 当前 translateY
      animating: false,
      dragFromHandle: false
    }
  },
  computed: {
    panelStyle() {
      return {
        transform: 'translateY(' + this.offsetY + 'px)'
      }
    },
    filteredProducts() {
      var kw = this.keyword.trim()
      if (!kw) return this.products || []
      return (this.products || []).filter(function (p) {
        var text =
          String(p.title || '') +
          String(p.subtitle || '') +
          String(p.index || '')
        return text.indexOf(kw) !== -1
      })
    }
  },
  watch: {
    visible(val) {
      if (val) {
        // 每次弹出时回到初始位置
        this.offsetY = 0
        this.offsetY = 0
        document.body.style.overflow = 'hidden'
        document.body.style.touchAction = 'none'
      } else {
        document.body.style.overflow = ''
        document.body.style.touchAction = ''
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
      this.resetDrag()
    },
    onSearch() {
      this.$emit('search', this.keyword.trim())
    },
    onSelect(item) {
      this.$emit('select', item)
    },
    onBuy(item) {
      this.$emit('buy', item)
    },

    // ======== 拖拽相关 ========

    onTouchStart(e) {
      if (!this.visible) return
      this.startY = e.touches[0].clientY
      this.baseOffsetY = this.offsetY
      this.animating = false

      // ✅ 只有从 header/handle 区域开始，才认为是“下拉关闭”
      const target = e.target
      this.dragFromHandle = !!(target && target.closest && target.closest('.sheet-header'))
      this.dragging = this.dragFromHandle
    },
    onTouchMove(e) {
      // ✅ 只有在拖拽关闭时才处理
      if (!this.dragging) return
      e.preventDefault()
      const currentY = e.touches[0].clientY
      let delta = currentY - this.startY
      if (delta < 0) delta = 0
      this.offsetY = this.baseOffsetY + delta
    },
    onTouchEnd() {
      if (!this.dragging) return
      this.dragging = false
      this.dragFromHandle = false
      this.animating = true

      const threshold = 120
      if (this.offsetY > threshold) {
        this.offsetY = window.innerHeight * 0.6
        setTimeout(() => this.handleClose(), 180)
      } else {
        this.offsetY = 0
        setTimeout(() => { this.animating = false }, 180)
      }
    },
    resetDrag() {
      this.dragging = false
      this.animating = false
      this.offsetY = 0
      this.baseOffsetY = 0
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
  display: none;
}

.sheet-root,
.sheet-panel {
  overscroll-behavior: contain;
}

.sheet-root {
  position: fixed;
  inset: 0;
  z-index: 40;
  display: flex;
  flex-direction: column;
}

.sheet-mask {
  position: fixed;
  height: 100vh;
  width: 100vw;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
}

/* 半屏面板 */
.sheet-panel {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  max-height: 50svh;
  /*半屏高度，可按需求调 */
  /* background: #fff; */
  border-top-left-radius: 18px;
  border-top-right-radius: 18px;
  /* box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.25); */
  display: flex;
  flex-direction: column;
  transform: translateY(0);
}

.sheet-panel--animating {
  transition: transform 0.18s ease-out;
}

/* 顶部区域 */
.sheet-header {
  padding-top: 6px;
  padding-bottom: 4px;
  position: relative;
}

.sheet-handle {
  width: 36px;
  height: 4px;
  border-radius: 2px;
  background: #dedede;
  margin: 0 auto 8px;
}

/* 顶部搜索 + 图标行 */
.sheet-topbar {
  display: flex;
  align-items: center;
  padding: 0 12px;
  position: relative;
}

/* 简单头像位（可替换 slot） */
.sheet-avatar {
  margin-right: 8px;
}

.sheet-avatar__circle {
  width: 28px;
  height: 28px;
  border-radius: 14px;
  background: #ff6a00;
  color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 搜索框 */
.sheet-search {
  flex: 1;
  height: 32px;
  border-radius: 16px;
  background: #f1f1f1;
  display: flex;
  align-items: center;
  padding: 0 10px;
}

.sheet-search__icon {
  font-size: 14px;
  margin-right: 4px;
}

.sheet-search__input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  width: 100%;
}

/* 右侧图标按钮 */
.sheet-icons {
  display: flex;
  align-items: center;
  margin-left: 8px;
  gap: 6px;
}

.sheet-icon-btn {
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  border: none;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  padding: 0;
}

.sheet-icon-badge {
  position: absolute;
  right: -3px;
  top: -3px;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  background: #ff3141;
  color: #fff;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Tabs */
.sheet-tabs {
  padding: 6px 12px 4px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
}

.sheet-tab {
  position: relative;
  color: #666;
}

.sheet-tab--active {
  color: #ff3141;
}

.sheet-tab--active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -3px;
  height: 2px;
  background: #ff3141;
  border-radius: 999px;
}

/* 列表 */
.sheet-list {
  /* flex: 1; */
  /* overflow-y: auto; */
  padding: 0 12px 12px;
  max-height: 38svh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-color: #fff;
}

.sheet-item {
  display: flex;
  padding: 10px;
  margin-bottom: 10px;
  /* border-radius: 12px; */
  background: #ffffff;
  border-bottom: 1px solid #eee;
  position: relative;
}

.sheet-item::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -1px;
  height: 2px;
  width: calc(100px);
  background-color: #fff;
}


/* .sheet-item--active {
  border: 1px solid #ff3141;
} */

/* 左侧缩略图 */
.item-thumb {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
}

.item-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.item-status {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(255, 75, 75, 0.9);
  color: #fff;
  font-size: 10px;
  padding: 2px 4px;
  text-align: center;
}

.item-index {
  position: absolute;
  left: 4px;
  top: 4px;
  padding: 0 4px;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-size: 10px;
}

/* 右侧信息 */
.item-info {
  flex: 1;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
}

.item-title {
  font-size: 13px;
  font-weight: 600;
  color: #222;
  line-height: 1.4;
  margin-bottom: 4px;
}

.item-subtitle {
  font-size: 12px;
  color: #ff3141;
  margin-bottom: 4px;
}

.item-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 4px;
}

.item-tag {
  font-size: 11px;
  color: #999;
}

/* 底部价格 + 按钮 */
.item-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
}

.item-price {
  display: flex;
  align-items: baseline;
  gap: 2px;
}

.item-price-symbol {
  font-size: 12px;
  color: #ff3141;
}

.item-price-value {
  font-size: 16px;
  font-weight: 600;
  color: #ff3141;
}

.item-price-origin {
  font-size: 11px;
  color: #999;
  text-decoration: line-through;
}

.item-buy {
  border: none;
  padding: 4px 12px;
  border-radius: 14px;
  background: #ff3141;
  color: #fff;
  font-size: 12px;
}

/* 空状态 */
.sheet-empty {
  padding: 24px 0;
  text-align: center;
  font-size: 13px;
  color: #999;
}


/* 右上关闭按钮 */
.live-hot-bar__close {
  position: absolute;
  right: 15px;
  top: 5px;
  border: none;
  outline: none;
  background: transparent;
  font-size: 12px;
  color: #999;
  padding: 2px;
  font-size: 30px;
}

/* ===== Header Redesign ===== */

.sheet-header {
  background: #fff;
  padding-bottom: 8px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

/* 顶部绿色活动条 */
.sheet-hero {
  padding: 8px 12px 20px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  font-size: 12px;
  position: relative;
  overflow: hidden;
  top: 15px;
  background-image: url(http://localhost:8889/img/holiday-gifts.098e7805.png),
    /* 🎁 左侧装饰 */
    repeating-linear-gradient(145deg, rgba(255, 255, 255, .18) 0 15px, rgba(255, 255, 255, 0) 15px 30px),
    /* 右侧斜纹 */
    linear-gradient(90deg, #1bbf7a, #16a34a);
  background-repeat: no-repeat, no-repeat, no-repeat;
  background-position: left 48% center, right -30px center, center;
  background-size: 120px auto, 160px 100%, 100% 100%;
}


.sheet-hero__tag {
  font-weight: 600;
}

.sheet-hero__link {
  opacity: 0.95;
}

/* 店铺信息行 */
.sheet-shop {
  margin: 8px 12px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sheet-shop__title {
  font-size: 14px;
  font-weight: 600;
  color: #111;
}

.sheet-shop__arrow {
  margin-left: 4px;
  color: #999;
}

.sheet-shop__meta {
  margin-top: 2px;
  font-size: 12px;
  color: #888;
}

.sheet-shop__icons {
  display: flex;
  gap: 8px;
}

.sheet-shop__icon {
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background: #f2f2f2;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

/* 优惠条 */
.sheet-coupon {
  margin: 8px 12px;
  padding: 8px 10px;
  background: #ffeef0;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sheet-coupon__text {
  font-size: 12px;
  color: #ff3141;
}

.sheet-coupon__btn {
  border: none;
  background: #ff3141;
  color: #fff;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 12px;
}
</style>
